import { render, staticRenderFns } from "./TituloSeccion.vue?vue&type=template&id=568f8682&scoped=true&"
import script from "./TituloSeccion.vue?vue&type=script&lang=js&"
export * from "./TituloSeccion.vue?vue&type=script&lang=js&"
import style0 from "./TituloSeccion.vue?vue&type=style&index=0&id=568f8682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568f8682",
  null
  
)

export default component.exports